import React, { useContext } from "react";
import "../../../../ui-styles/sliders/RightFullSlider.css"
import "../../../../ui-styles/advice/AdviceInfo.css";
import "../../../../ui-styles/nodata/NoData.css";
import { LangCtx } from "../../../../lib/context";


const DocAdviceSlide = (props) => {
        const { l } = useContext(LangCtx);
        return (
            <div className={props.docAdvice ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
                <div className="rightSliderHdr">
                    <div className="hdrRowBlock">
                        <div className="hdrTitleBox">
                            <span>{l.doc_advice}</span>
                        </div>
                        <div className="hdrActionGroup" onClick={props.close}>
                            <div className="hdrActItem close"></div>
                        </div>
                    </div>
                </div>

                <div className="rightSliderBdy">
                    <div className="adviceHdr">
                        <span className="adviceTxtL">{l.dr} {props.docAdviceData["docName"]}</span>
                        <span className="adviceTxtS">{l.label_patient} {props.docAdviceData["name"]}</span>
                    </div>
                    <div className="nodataBlock flexOne">
                        <div className="ndIconBox">
                            <img src="/images/icons/doc-advice.png" alt="icon" />
                        </div>
                        <span className="nodataHdng">{l.no_advice}</span>
                        <span className="txtMd">{l.no_adv_txt}</span>
                    </div>
                </div>
           </div>
        )
    }
export default DocAdviceSlide
